<button
    type="button"
    class="flex h-[32px] w-[32px] items-center justify-center rounded-lg transition-all duration-200 hover:scale-110"
    [ngClass]="
        layoutService.isDarkTheme()
            ? 'bg-violet-500/10 text-violet-400'
            : 'bg-yellow-400/10 text-yellow-500'
    "
    [attr.aria-label]="layoutService.isDarkTheme() ? 'Switch to light mode' : 'Switch to dark mode'"
    [pTooltip]="layoutService.isDarkTheme() ? 'Light mode' : 'Dark mode'"
    tooltipPosition="bottom"
    data-testid="topbar-dark-mode-toggle"
    (click)="layoutService.toggleDarkMode()"
>
    <i
        class="text-xl!"
        [ngClass]="layoutService.isDarkTheme() ? 'pi pi-sun' : 'pi pi-moon'"
        aria-hidden="true"
    ></i>
</button>

<div class="h-6 w-px bg-[var(--topbar-section-border)]" aria-hidden="true"></div>

<button
    type="button"
    class="flex h-[32px] w-[32px] items-center justify-center rounded-lg text-[var(--topbar-text-muted)] transition-all duration-200 hover:scale-110 hover:text-[var(--topbar-text)]"
    aria-label="Open theme configurator"
    pTooltip="Theme colors"
    tooltipPosition="bottom"
    data-testid="topbar-theme-config"
    (click)="config.toggle($event)"
>
    <i class="pi pi-palette text-xl!" aria-hidden="true"></i>
</button>

<p-popover #config styleClass="layout-topbar-popover">
    <div class="flex w-[240px] flex-col gap-4">
        <div>
            <p
                class="text-xs font-semibold text-[var(--text-color-secondary)] uppercase tracking-widest mb-2"
            >
                Primary
            </p>
            <div class="flex flex-wrap gap-1.5">
                @for (color of primaryColors; track color.name) {
                    <button
                        type="button"
                        class="w-6 h-6 rounded-full border-2 cursor-pointer transition-all duration-150 hover:scale-110 focus:outline-none"
                        [style.background-color]="color.value"
                        [style.box-shadow]="'0 0 0 1px rgba(255,255,255,0.3)'"
                        [ngClass]="
                            currentPrimary === color.name
                                ? 'border-white ring-2 ring-offset-1 ring-[var(--primary-color)] scale-110'
                                : 'border-transparent'
                        "
                        [attr.aria-label]="color.name"
                        (click)="selectPrimary(color.name)"
                    ></button>
                }
            </div>
        </div>
        <div>
            <p
                class="text-xs font-semibold text-[var(--text-color-secondary)] uppercase tracking-widest mb-2"
            >
                Surface
            </p>
            <div class="flex flex-wrap gap-1.5">
                @for (color of surfaceColors; track color.name) {
                    <button
                        type="button"
                        class="w-6 h-6 rounded-full border-2 cursor-pointer transition-all duration-150 hover:scale-110 focus:outline-none"
                        [style.background-color]="color.value"
                        [style.box-shadow]="'0 0 0 1px rgba(255,255,255,0.3)'"
                        [ngClass]="
                            currentSurface === color.name
                                ? 'border-white ring-2 ring-offset-1 ring-[var(--primary-color)] scale-110'
                                : 'border-transparent'
                        "
                        [attr.aria-label]="color.name"
                        (click)="selectSurface(color.name)"
                    ></button>
                }
            </div>
        </div>
    </div>
</p-popover>
